/**
* Class to work as a DTO to hold the information of a event dispatched to segment.
*/
class SegmentEvent {   
    constructor(name = '', customProperties = {}) {
      this.name = name;
      this.properties = customProperties;
    }
  }
  
  export default SegmentEvent;